<template>
  <v-dialog v-model="open" scrollable persistent max-width="900px">
    <v-card>
      <v-card-title>
        <v-icon class="c-ttl-icon" color="clr-primary">mdi-image-multiple</v-icon>
        <span class="c-ttl">{{ $T('page.album.add.picture.title') }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <!-- Share target: the talk's community (icon) + the target members (read-only), like the -->
        <!-- POST/event dialogs. The media are shared with these members (see onSending). -->
        <selected-members
          class="c-mems"
          :cid="cid"
          :cIcon="true"
          :memberGroups="members"
          :includeInactive="false"
          iconColor="clr-black"
          type="talk"
          :typeId="tid"
          :hideNoMemberMsg="true"
        ></selected-members>
        <form enctype="multipart/form-data">
          <v-flex>
            <!-- The same file-selection + upload-progress widget as the album page (image / video only). -->
            <dropzone
              id="talkDz"
              type="album"
              uploadUrl="/api/upload/album"
              ref="dz"
              :cid="cid"
              :forAlbum="true"
              :checkDup="false"
              @success="onSuccess"
              @sending="onSending"
              @sendErr="onSendErr"
              @queueComplete="onQueueComplete"
            />
          </v-flex>
        </form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="c-btn-actions">
        <v-spacer></v-spacer>
        <v-btn v-if="!uploading" :small="leTbS" color="clr-btn" outline @click.native="onClickUpload" :loading="loading">{{
          $T('button.upload')
        }}</v-btn>
        <v-btn v-else :small="leTbS" color="clr-btn-cancel" outline @click.native="stopUpload" :disabled="!loading">{{
          $T('button.cancel')
        }}</v-btn>
        <v-btn color="clr-btn" :small="leTbS" flat @click.native="closeDialog">{{ $T('button.close') }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dropzone from '../common/Dropzone.vue';
import { getStorageUsage } from '../../api/file';
import { addMsgAlbum } from '../../api/communityTalk';

export default {
  components: {
    dropzone: dropzone,
  },
  props: {
    value: { type: Boolean, required: true },
    cid: { type: Number, required: true },
    tid: { type: Number, required: true },
    // talk participant keys (m<cmid>) the uploaded media are shared with
    members: { type: Array, required: false },
  },
  data() {
    return {
      open: this.value,
      loading: false,
      fids: [],
    };
  },
  computed: {
    uploading() {
      return this.$store.state.file.uploading;
    },
  },
  watch: {
    value(n) {
      this.open = n;
    },
    open(n) {
      this.$emit('input', n);
    },
  },
  methods: {
    onClickUpload() {
      if (!this.$refs.dz.validate()) return;
      this.fids = [];
      var self = this;
      getStorageUsage(this.cid)
        .then(function(data) {
          self.execUpload(data[self.cid]);
        })
        .catch(function(e) {
          console.error(e);
          self.shortMsg($T('common.err.getdata'), true);
        });
    },
    execUpload(volume) {
      if (this.$refs.dz.startSending(volume)) this.loading = true;
    },
    stopUpload() {
      this.loading = false;
      this.$refs.dz.cancel();
    },
    onSending(file, xhr, formData) {
      var ms = this.members;
      if (!ms || ms.length == 0) ms = ['m' + this.cidToCmid(this.cid)];
      formData.append('cid', this.cid);
      formData.append('members', ms);
      formData.append('share_pict_time', true);
      formData.append('use_update_time', true);
      formData.append('check_dup', false);
    },
    onSuccess(file, data) {
      // upload body is {item:{id}, cid, ym, full} (Dropzone already unwrapped .data)
      if (data && data.item && data.item.id) this.fids.push(data.item.id);
    },
    onSendErr() {},
    onQueueComplete() {
      this.loading = false;
      if (this.fids.length == 0) return;
      var self = this;
      var data = new FormData();
      data.append('tid', this.tid);
      data.append('fids', this.fids.join(','));
      addMsgAlbum(data)
        .then(function(response) {
          self.$emit('sent', response.data);
          self.closeDialog();
        })
        .catch(function(e) {
          console.error(e);
          self.shortMsg($T('common.failed.register'), true);
        });
    },
    closeDialog() {
      this.open = false;
    },
  },
};
</script>

<style scoped>
.c-ttl-icon {
  margin-right: 6px;
}
.c-ttl {
  font-size: 16px;
}
.c-mems {
  margin-bottom: 12px;
}
.c-btn-actions {
  overflow: hidden;
  padding: 10px 5px !important;
}
</style>
